<div class="select-deposit" *ngIf="!allButtonsFalse">
  <div class="select-deposit__info">
    <h2 class="select-deposit__info__title">
      {{ 'Selectdeposit.select_deposit_title' | translate }}
    </h2>
    <p class="select-deposit__info__text">
      {{ 'Selectdeposit.select_deposit_text_1' | translate }}
      <span>{{ 'Deposit.receiver_account' | translate }}</span>
      {{ 'Selectdeposit.select_deposit_text_2' | translate }}
    </p>
  </div>
  <div class="select-deposit__actions">
    <button
      type="button"
      class="btn--quaternary-small"
      *ngIf="buttonsToShow.button12"
      (click)="navigateToDepositHire(12)"
    >
      {{ 'Deposit.receiver_account' | translate }}
      {{ 'Monthlyfilters.monthly_filters_12' | translate }}
    </button>
    <button
      type="button"
      class="btn--quaternary-small"
      *ngIf="buttonsToShow.button24"
      (click)="navigateToDepositHire(24)"
    >
      {{ 'Deposit.receiver_account' | translate }}
      {{ 'Monthlyfilters.monthly_filters_24' | translate }}
    </button>
    <button
      type="button"
      class="btn--quaternary-small"
      *ngIf="buttonsToShow.button36"
      (click)="navigateToDepositHire(36)"
    >
      {{ 'Deposit.receiver_account' | translate }}
      {{ 'Monthlyfilters.monthly_filters_36' | translate }}
    </button>
  </div>
</div>
